export const exportToCSV = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob(data, { type: 'text/csv' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName + '.csv');
  document.body.appendChild(link);
  link.click();
};
